// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Chip as HeroChip } from "@heroui/react";
import { clsx } from "clsx";
import type { ReactNode } from "react";

export type StatusChipTone =
  | "neutral"
  | "brand"
  | "info"
  | "success"
  | "warning"
  | "danger";
export type StatusChipVariant = "soft" | "solid" | "outline";
export type StatusChipSize = "sm" | "md" | "lg";

export interface StatusChipProps {
  children: ReactNode;
  tone?: StatusChipTone;
  variant?: StatusChipVariant;
  size?: StatusChipSize;
  dot?: boolean;
  className?: string;
}

const colorByTone = {
  neutral: "default",
  brand: "accent",
  info: "accent",
  success: "success",
  warning: "warning",
  danger: "danger",
} as const;

const variantMap = {
  soft: "soft",
  solid: "primary",
  outline: "tertiary",
} as const;

export function StatusChip({
  children,
  tone = "neutral",
  variant = "soft",
  size = "sm",
  dot = false,
  className,
}: StatusChipProps) {
  return (
    <HeroChip.Root
      color={colorByTone[tone]}
      variant={variantMap[variant]}
      size={size}
      data-tone={tone}
      className={clsx("tapp-status-chip", className)}
    >
      <HeroChip.Label>
        {dot && (
          <span
            className="tapp-status-chip__dot"
            aria-hidden="true"
          />
        )}
        {children}
      </HeroChip.Label>
    </HeroChip.Root>
  );
}
